import type { EditAsideWebBannerHighlight } from '@nodeTypeConfig/configTypes';
import { updateWebsiteConfigurationActionNew } from '@store/actions/documentActions';
import { get } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentWebConfig } from '../../../hooks/UseCurrentWebConfig';
import { useEditHref } from '../../../hooks/UseEditHref';
import SimpleCheckbox from '../../SimpleCheckbox';

const AsideWebSimpleCheckbox: React.FC<{
  config: EditAsideWebBannerHighlight;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const currentWebConfig = useCurrentWebConfig();
  const initialValue = get(currentWebConfig, config.property, false);

  const change = (value: boolean) => {
    dispatch(updateWebsiteConfigurationActionNew(editHref, config.property, value));
  };

  return (
    <SimpleCheckbox
      checked={initialValue}
      label={config.label}
      readOnly={readonly}
      onChange={change}
    />
  );
};

export default AsideWebSimpleCheckbox;

AsideWebSimpleCheckbox.displayName = 'AsideWebSimpleCheckbox';

AsideWebSimpleCheckbox.propTypes = {
  config: any,
  readonly: any,
};
